module.exports = __webpack_public_path__ + "static/pci-security-standard-fabfa555c177f74d2e1ea4349b5aa4ef.png";